<template>
  <labeled-form-control label="Any notes for us?" :optional="true">
    <textarea v-model="noteText" class="form-control" cols="50" rows="5" :disabled="clientNoteUpdated" maxlength="4000"></textarea>
  </labeled-form-control>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { ClientNoteUploadMixin } from '../../../mixins/Registration/ClientNoteUploadMixin'
import { ClientOnboardingInviteCacheMixin } from '../../../mixins/Registration/ClientOnboardingInviteCacheMixin'
import LabeledFormControl from '../../Layout/LabeledFormControl.vue'

export default {
  name: 'ClientMedicalNote',
  mixins: [ClientNoteUploadMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ownerId () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientId : ''
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    clientAddressUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setClientNoteUpdated'
    ]),
    afterUpdateClientNote () {
      this.setClientNoteUpdated()
    },
    afterAddClientNote () {
      this.setClientNoteUpdated()
    },
    handleUpdateEvent () {
      if (!this.clientNoteUpdated && this.clientAddressUpdated) {
        this.tryUploadClientNote()
      }
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
